import React from 'react';
import {
  Box,
  Typography,
  Button,
  Container,
  Chip,
  Stack,
} from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { WHATSAPP_URL, CALENDLY_URL } from '../constants/site';
import { trackEvent } from '../utils/analytics';
import { brandColors } from '../theme';

const Hero = () => {
  const openWhatsApp = () => {
    trackEvent('cta_click', { location: 'hero', type: 'whatsapp' });
    window.open(WHATSAPP_URL, '_blank', 'noopener,noreferrer');
  };

  const openCalendly = () => {
    trackEvent('cta_click', { location: 'hero', type: 'calendly' });
    window.open(CALENDLY_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        alignItems: 'center',
        mt: { xs: '-56px', sm: '-64px' },
        pt: { xs: 16, md: 18 },
        pb: { xs: 8, md: 10 },
        position: 'relative',
        overflow: 'hidden',
        background: `linear-gradient(160deg, ${brandColors.navy} 0%, ${brandColors.slate} 45%, #243B5C 100%)`,
        color: '#fff',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background:
            'radial-gradient(ellipse 80% 60% at 70% 20%, rgba(201,169,98,0.15) 0%, transparent 55%)',
          pointerEvents: 'none',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: 80,
          background: `linear-gradient(180deg, transparent, ${brandColors.ice})`,
          pointerEvents: 'none',
        },
      }}
    >
      <Container
        maxWidth="md"
        sx={{
          position: 'relative',
          zIndex: 1,
          textAlign: 'center',
          px: { xs: 2, sm: 3 },
        }}
      >
        <Chip
          label="Tecnología · Datos · Automatización"
          sx={{
            mb: 3,
            maxWidth: '100%',
            height: 'auto',
            py: 0.75,
            bgcolor: 'rgba(201, 169, 98, 0.15)',
            color: brandColors.goldLight,
            border: '1px solid rgba(201, 169, 98, 0.35)',
            fontWeight: 600,
            fontSize: { xs: '0.7rem', sm: '0.75rem' },
            '& .MuiChip-label': {
              whiteSpace: 'normal',
              px: { xs: 1, sm: 1.5 },
            },
          }}
        />
        <Typography
          variant="h1"
          component="h1"
          sx={{
            fontSize: { xs: '1.85rem', sm: '2.4rem', md: '3rem' },
            fontWeight: 800,
            color: '#fff',
            mb: 2,
            letterSpacing: '-0.03em',
            px: { xs: 0.5, sm: 0 },
          }}
        >
          Tecnología y datos que{' '}
          <Box
            component="span"
            sx={{
              background: `linear-gradient(90deg, ${brandColors.goldLight}, ${brandColors.gold})`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            generan resultados
          </Box>
          .
        </Typography>
        <Typography
          variant="h6"
          component="p"
          sx={{
            color: 'rgba(255,255,255,0.8)',
            fontWeight: 400,
            lineHeight: 1.65,
            maxWidth: 560,
            mx: 'auto',
            mb: 4,
            fontSize: { xs: '0.95rem', md: '1.15rem' },
            px: { xs: 0.5, sm: 0 },
          }}
        >
          Diseñamos e implementamos soluciones digitales para empresas: datos útiles,
          procesos automatizados y software a medida que ahorran costos y abren ingresos.
        </Typography>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          justifyContent="center"
          alignItems="stretch"
          sx={{ width: '100%', maxWidth: 480, mx: 'auto' }}
        >
          <Button
            variant="contained"
            color="secondary"
            size="large"
            startIcon={<WhatsAppIcon />}
            onClick={openWhatsApp}
            sx={{ py: 1.5, px: 3, width: { xs: '100%', sm: 'auto' } }}
          >
            Hablar por WhatsApp
          </Button>
          <Button
            variant="outlined"
            size="large"
            startIcon={<CalendarMonthIcon />}
            onClick={openCalendly}
            sx={{
              py: 1.5,
              px: 3,
              width: { xs: '100%', sm: 'auto' },
              color: '#fff',
              borderColor: 'rgba(255,255,255,0.4)',
              '&:hover': {
                borderColor: brandColors.gold,
                bgcolor: 'rgba(255,255,255,0.06)',
              },
            }}
          >
            Agendar llamada
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default Hero;
